import { Avatar, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@bvhi/ui-base";
import { LogoutIcon, PersonIcon } from "@bvhi/ui-icons";
import { useNavigate } from "@tanstack/react-router";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../context/use-auth-context";
import { useAuthentication } from "../hooks/use-authentication";

export const UserAvatar = () => {
  const { currentUser } = useAuthContext();
  const { t } = useTranslation(["common"]);
  const { logout } = useAuthentication();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const menuIsOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const avatarLabel = useMemo(() => {
    if (!currentUser?.firstName || !currentUser.lastName) return <PersonIcon />;
    if (currentUser.firstName.length < 1 || currentUser.lastName.length < 1) return <PersonIcon />;
    return `${currentUser.firstName[0]}${currentUser.lastName[0]}`;
  }, [currentUser]);

  if (!currentUser) return;
  return (
    <>
      <IconButton
        aria-controls={menuIsOpen ? "account-menu" : undefined}
        aria-expanded={menuIsOpen ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ width: 40, height: 40 }}>{avatarLabel}</Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        id="account-menu"
        onClose={handleClose}
        open={menuIsOpen}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: 350,
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1,
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: (theme) => theme.palette.background.paper,
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            void navigate({ to: "/profile/details" });
          }}
        >
          <Avatar sx={{ marginRight: (theme) => theme.spacing(2), width: 40, height: 40 }}>{avatarLabel}</Avatar>
          <Typography noWrap>
            {t("common:button.profile.details", { firstName: currentUser.firstName, lastName: currentUser.lastName })}
          </Typography>
        </MenuItem>

        <Divider />

        <MenuItem onClick={() => logout()}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText>{t("button.logout")}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
